<template>
  <v-row ref="imageElement" :style="{ position: 'relative' }">
    <v-col>
      <v-row>
        <v-col class="text-center">
          <v-file-input
            id="idPortalSeleccionarArchivo"
            filled
            dense
            v-if="editable"
            accept="image/png, image/jpeg, image/bmp"
            placeholder="Elige una imagen"
            prepend-icon="mdi-camera"
            label="Imagen"
            color="tertiary"
            @change="handleImageChange"
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center" cols="12">
          <template
            v-if="!avatarUrl && showInitials"
            :style="{
              width,
              height,
              'border-radius': rounded ? '100%' : '0'
            }"
            class="initials-container"
          >
            <v-avatar
              color="primary"
              :style="{ 'font-size': fontSize, color }"
              size="150"
            >
              {{ getInitials() }}
            </v-avatar>
          </template>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <img
            v-if="avatarUrl"
            :src="avatarUrl"
            class="mt-4"
            :style="{
              width,
              height,
              'border-radius': rounded ? '100%' : '0',
              filter: editable ? 'brightness(1)' : 'none'
            }"
          />
        </v-col>
      </v-row>
      <v-row v-if="editable">
        <v-col class="text-center">
          <v-btn rounded color="primary" outlined @click="removeImage()">
            Eliminar imagen
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    width: { type: String, default: '200px' },
    height: { type: String, default: '200px' },
    top: { type: String, default: '40px' },
    color: { type: String, default: '#FFF' },
    initialAvatarUrl: { type: String, default: null },
    value: String
  },
  data() {
    return {
      avatarUrl: this.initialAvatarUrl,
      showInitials: !this.initialAvatarUrl,
      hasImage: false
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'personData']),
    avatarUrl() {
      return this.value
    },
    userInfo() {
      return this.user
    },
    fontSize() {
      const element = this.$refs.imageElement
      if (element) {
        const width = element.offsetWidth * 0.1
        const height = element.offsetHeight * 0.1
        return `${Math.min(width, height, 14)}pt`
      } else {
        return '34pt'
      }
    }
  },
  watch: {
    value(newVal) {
      this.avatarUrl = newVal
      this.showInitials = !newVal
      this.hasImage = !!newVal
    }
  },
  methods: {
    removeImage() {
      this.avatarUrl = null
      this.$emit('image-updated', {
        avatar: this.avatarUrl,
        hasImage: this.hasImage
      })
    },
    handleImageChange(file) {
      if (file) {
        const reader = new FileReader()
        reader.onload = e => {
          this.avatarUrl = e.target.result
          this.showInitials = false
          this.hasImage = true
          this.$emit('image-updated', {
            avatar: this.avatarUrl,
            hasImage: this.hasImage
          })
        }
        reader.readAsDataURL(file)
      } else {
        this.avatarUrl = null
        this.showInitials = true
        this.hasImage = false
        this.$emit('image-updated', { avatar: null, hasImage: this.hasImage })
      }
    },
    getInitials() {
      const { name, last_name } = JSON.parse(localStorage.getItem('user'))
      return (
        (name ? name.charAt(0) : '') + (last_name ? last_name.charAt(0) : '')
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.controls {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;
  cursor: pointer;

  > i {
    margin-bottom: 5px;
  }

  > p {
    font-weight: bold;
    color: white;
    width: 80%;
    margin: 0;
  }
  .initials-container {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5em;
    background-color: #3498db; // Puedes cambiar este color según tus preferencias
  }
}
</style>
